import {IOpenQuestion} from "../interface/IOpenQuestion.interface"

export const EmptyOpenQuestion: IOpenQuestion = {
    question: "",
    type: "open-question",
    selected: false,
    description: "",
}